import { toast } from 'sonner'
import i18n from './i18n'
import { onEvent } from './events'

export function initUpgradeToastSubscriber(): void {
  onEvent('subscription.upgraded', (payload) => {
    toast(i18n.t('mori.upgradeWelcome', { tier: capitalize(payload.toTier) }))
  })
}

function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1)
}
